__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/406b64d/_next/";